// LoginModal.tsx
import React, { useState } from 'react';
import LoginComponent from './LoginComponent';
import RegisterComponent from './RegisterComponent';
import { useApi } from '../../services/ApiServices';
import { Google as GoogleIcon, Facebook as FacebookIcon, Apple as AppleIcon, Close as CloseIcon, VisibilityOff, Visibility } from '@mui/icons-material';
import { Dialog, DialogContent, IconButton, Button, Typography, Grid, Grid2, FormControlLabel, Checkbox, Avatar } from '@mui/material';
import { PrivacyBadge } from '../PrivacyBadge';


// const rechaptchaSiteKey = process.env.REACT_APP_GCP_RECAPTCHA_SECRET_KEY;
const rechaptchaSiteKey = window.GCP_RECAPTCHA_SECRET_KEY || "6LdP2RArAAAAAAiN3Ppq6NN9LIPXKdHpcsWHictT";

const logoMenuBlanco = require('../../assets/img/logo-menu-white.png');
const defaultAvatar = require('../../assets/img/chilin-profile.png');
const iconoSeparador = require('../../assets/img/icon-separator.png');
const upLoadIcon = require('../../assets/img/Upload.png');


interface LoginModalProps {
  open: boolean;
  onClose: () => void;
  rechaptchaSiteKey?: string;
  onLoginSuccess?: (data: any) => void;
}

const LoginModal: React.FC<LoginModalProps> = ({ open, onClose, onLoginSuccess }) => {
  // true: se muestra la parte de registro; false: se muestra login
  const [isRegister, setIsRegister] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [isRegisterStep2, setIsRegisterStep2] = useState(false);
  const [isRegisterStep3, setIsRegisterStep3] = useState(false);
  const [isForgetPassword, setIsForgetPassword] = useState(false);
  const [isForgetPasswordStep2, setIsForgetPasswordStep2] = useState(false);
  const [isForgetPasswordStep3, setIsForgetPasswordStep3] = useState(false);
  const [isForgetUser, setIsForgetUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emailOrUser, setEmailOrUser] = useState('');
  const [avatar, setAvatar] = React.useState('');
  const [imagenBase64, setImagenBase64] = React.useState(''); // Para enviar al servicio
  const [emailRecoveryUser, setEmailRecoveryUser] = useState('');
  const [emailRecoveryPassword, setEmailRecoveryPassword] = useState('');
  const [code, setCode] = useState(Array(6).fill(""));
  const [tokenRecoveryPassword, setTokenRecoveryPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [passwordRegisterRecoveryPassword, setPasswordRegisterRecoveryPassword] = useState('');
  const [passwordConfirmationRecoveryPassword, setPasswordConfirmationRecoveryPassword] = useState('');
  const [showPasswordRecovery, setShowPasswordRecovery] = useState(false);
  const [showPasswordConfirmRecovery, setShowPasswordConfirmRecovery] = useState(false);


  const switchToRegister = () => setIsRegister(true);
  const switchToLogin = () => setIsRegister(false);

  const { ApiRequest } = useApi();

  const handleOtroMomento = async () => {
    resetScreen();
    setIsRegisterStep3(true);
  };

  const handleRegisterRecoveryPassword = async () => {
    // Valida que los campos no estén vacíos
    if (!passwordRegisterRecoveryPassword || !passwordConfirmationRecoveryPassword) {
      alert('Por favor, completa todos los campos.');
      return;
    }
    if (passwordRegisterRecoveryPassword !== passwordConfirmationRecoveryPassword) {
      alert('La contraseña debe ser la misma.');
      return;
    }

    try {
      setIsLoading(true);
      const body = JSON.stringify(
        {
          token: tokenRecoveryPassword,
          email: emailRecoveryPassword,
          newPassword: passwordRegisterRecoveryPassword
        }
      );
      const responseRegiser = await ApiRequest('api/Auth/RecepcionTokenRecuperacionContrasena', 'PUT', body, true);
      console.log("register", responseRegiser);

      if (responseRegiser.error) {
        alert(responseRegiser.error);
      } else {
        resetScreen();
        setIsLogin(true);
        /*
        const bodyLogin = JSON.stringify({ username: emailOrUser, password: passwordRegister });
        const response = await ApiRequest('api/Auth/Login', 'POST', bodyLogin, true);
        console.log("loginFromRegister", response);
        const data: LoginResponse = response;
  
        if (data.token && data.user && data.user !== null && data.token !== "") {
          login(data.user, data.token);
          //onClose();
          setIsRegister(false);
          setIsRegisterStep2(true);
        } else {
          alert(data.error || 'Error al completar el registro');
        }
        */
      }

    } catch (error) {
      alert('Hubo un error al iniciar sesión. Inténtalo nuevamente.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        if (typeof base64String === 'string') {
          setAvatar(base64String); // Actualiza la vista previa
          setImagenBase64(base64String); // Guarda el base64 para enviar al servicio
        } else {
          console.error('El resultado del FileReader no es una cadena.');
        }
      };
      reader.readAsDataURL(file); // Convierte la imagen a base64
    }
  };

  const handleCodeChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9a-zA-Z]?$/.test(value)) { // Solo permitir caracteres alfanuméricos
      const updatedCode = [...code];
      updatedCode[index] = value;
      setCode(updatedCode);

      // Intentar enfocar el siguiente input si no es el último
      const nextInput = document.getElementById(`code-input-${index + 1}`);
      if (nextInput) {
        (nextInput as HTMLInputElement).focus(); // Asegurarte de que es un HTMLInputElement
      }
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleRecovery = async () => {
    // Valida que los campos no estén vacíos
    if (!emailRecoveryPassword) {
      alert('Por favor, completa todos los campos.');
      return;
    }

    try {
      setIsLoading(true);
      const responseRecovery = await ApiRequest(`api/Auth/ObtenerCodigoRecuperacion?email=${emailRecoveryPassword}`, 'GET', null, true);
      console.log("recovery", responseRecovery);

      if (responseRecovery.error) {
        alert(responseRecovery.error);
      } else {
        resetScreen();
        setIsForgetPasswordStep2(true);
      }

    } catch (error) {
      alert('Hubo un error al iniciar sesión. Inténtalo nuevamente.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmNumber = async () => {
    // Valida que los campos no estén vacíos
    if (!emailRecoveryPassword) {
      alert('Por favor, completa todos los campos.');
      return;
    }

    try {
      setIsLoading(true);
      const body = JSON.stringify({ codigo: code.join(""), email: emailRecoveryPassword });
      const responseRecovery = await ApiRequest(`api/Auth/ValidaCodigoRecuperacion`, 'POST', body, true);
      console.log("recovery", responseRecovery);

      if (responseRecovery.error) {
        alert(responseRecovery.error);
      } else {
        setTokenRecoveryPassword(responseRecovery.token);
        resetScreen();
        setIsForgetPasswordStep3(true);
      }

    } catch (error) {
      alert('Hubo un error al iniciar sesión. Inténtalo nuevamente.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitAvatar = async () => {
    if (!imagenBase64 || !emailOrUser) {
      alert('Por favor, completa todos los campos.');
      return;
    }

    try {
      const body = JSON.stringify({ imagenBase64: imagenBase64, email: emailOrUser });
      const response = await ApiRequest('api/Auth/ActualizaAvatar', 'POST', body, true);
      console.log("avatar", response);

      //const data: LoginResponse = response;

      handleOtroMomento();
    } catch (error) {
      alert('Hubo un error al iniciar sesión. Inténtalo nuevamente.');
      console.error(error);
    }
  };

  const handleRecoveryUser = async () => {
    // Valida que los campos no estén vacíos
    if (!emailRecoveryUser) {
      alert('Por favor, completa todos los campos.');
      return;
    }

    try {
      setIsLoading(true);
      const responseRecovery = await ApiRequest(`api/Auth/EnvioMailRecuperacionUsuario?email=${emailRecoveryUser}`, 'GET', null, true);
      console.log("recovery", responseRecovery);

      if (responseRecovery.error) {
        alert(responseRecovery.error);
      } else {
        resetScreen();
        setIsLogin(true);
      }

    } catch (error) {
      alert('Hubo un error al iniciar sesión. Inténtalo nuevamente.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitAvatarFinalizar = async () => {
    if (!imagenBase64 || !emailOrUser) {
      //alert('Por favor, completa todos los campos.');
      handleOtroMomento();
      setIsLogin(true);
      onClose();
      return;
    } else {

      try {
        const body = JSON.stringify({ imagenBase64: imagenBase64, email: emailOrUser });
        const response = await ApiRequest('api/Auth/ActualizaAvatar', 'POST', body, true);
        console.log("avatar", response);

        //const data: LoginResponse = response;

        handleOtroMomento();
        setIsLogin(true);
        onClose();
      } catch (error) {
        alert('Hubo un error al iniciar sesión. Inténtalo nuevamente.');
        console.error(error);
      }
    }
  };

  function openRegister() {
    resetScreen();
    setIsRegister(true);
  }

  function openRecoveryPassword() {
    resetScreen();
    setIsForgetPassword(true);
  }

  function resetScreen() {
    setIsLogin(false);
    setIsRegister(false);
    setIsRegisterStep2(false);
    setIsRegisterStep3(false);
    setIsForgetPassword(false);
    setIsForgetPasswordStep2(false);
    setIsForgetPasswordStep3(false);
    setIsForgetUser(false);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="login-modal-title"
      PaperProps={{
        className: 'login-modal-parent', //'login-modal-paper', // Clase CSS para los estilos del modal
      }}
    >
      <Grid2 className="modal-content-login">
        <img src={logoMenuBlanco} alt="Logo" className="login-logo" />
        <IconButton className="close-button" onClick={() => {
          setIsLogin(true);
          onClose();
        }}><CloseIcon /></IconButton>
        {isLogin ? (
          <LoginComponent
            onLoginSuccess={onLoginSuccess}
            onSwitchToRegister={switchToRegister}
            onClose={onClose}
            rechaptchaSiteKey={rechaptchaSiteKey}
          />
        ) : isRegister ? (
          <RegisterComponent
            onRegisterSuccess={(chidlEmal) => {
              // Puedes agregar lógica post registro y luego cambiar a login o cerrar el modal.
              resetScreen();
              setIsRegisterStep2(true);
              setEmailOrUser(chidlEmal);
            }}
            onSwitchToLogin={switchToLogin}
            onClose={onClose}
            rechaptchaSiteKey={rechaptchaSiteKey}
          />
        ) : isRegisterStep2 ? (
          <DialogContent className="login-modal-paper-register">
            <Grid2 className="login-modal-content">
              <Grid2 className="main-text">
                <span className="highlight-black">Bienvenida</span>&nbsp;
              </Grid2>
              <Grid2 className="main-text2">
                <span className="highlight-gray">{emailOrUser}</span>
              </Grid2>
              <Grid2 className="main-text3">
                <span className="highlight-gray">Para personalizar aún más tu experiencia puedes subir una foto tuya</span>
              </Grid2>

              <Grid container direction="column" spacing={2} className="modal-container-title">
                <Typography variant="h6" className="login-title">
                  Editar tu foto o avatar
                </Typography>
                <Grid2 container
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  className="login-search-box"
                  onClick={() => document.getElementById('file-input')?.click()}>
                  {/* Estilizas el login search box como quieras */}
                  <span>Sube tu mejor foto, no olvides sonreir</span>
                  <img
                    src={upLoadIcon}
                    alt="Ícono para subir imagen"
                    style={{ width: '20px', height: '20px', marginLeft: '150px' }}
                  />
                </Grid2>

                {/* Input file oculto */}
                <input
                  id="file-input"
                  type="file"
                  accept="image/*"
                  className="login-search-input"
                  style={{ display: 'none' }} // Oculta el input de tipo file
                  onChange={handleImageChange} // Función que se encargará de convertir la imagen a base64
                />


                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Avatar
                    src={avatar || defaultAvatar}
                    alt="profile"
                    sx={{ width: 256, height: 256, marginRight: '8px' }}
                  />
                </Grid2>

                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Button
                    className="otro-momento-button-enviar"
                    variant="text"
                    color="info"
                    style={{
                      color: '#666666',
                      textDecoration: 'underline',
                      textUnderlinePosition: 'from-font',
                      textDecorationSkipInk: 'none',
                      textTransform: 'none'
                    }}
                    onClick={handleOtroMomento}
                  >
                    En otro momento
                  </Button>
                  <Button
                    className="login-button-enviar"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitAvatar}
                    style={{ textTransform: 'none' }}
                  >
                    Siguiente
                  </Button>
                </Grid2>
              </Grid>
            </Grid2>
          </DialogContent>
        ) : isRegisterStep3 ? (
          <DialogContent className="login-modal-paper-register">
            <Grid2 className="login-modal-content-step3">
              <Grid2 className="main-text2">
                <span className="highlight-gray">{emailOrUser}</span>
              </Grid2>
              <Grid2 className="main-text" sx={{ width: '100%', textAlign: 'center' }}>
                <span className="highlight-black">Tu registro ha sido exitoso</span>&nbsp;
              </Grid2>

              <Grid2 className="main-text4">
                <span className="highlight-gray">Hemos enviado un correo a tu dirección de email con un enlace de activación. Por favor, revisa tu bandeja de entrada (y, en caso de no verlo, la carpeta de spam) para completar el proceso de activación de tu cuenta.</span>
              </Grid2>
              <Grid container direction="column" spacing={2} className="modal-container-title">
                <Typography variant="h6" className="login-title">
                  Editar tu foto o avatar
                </Typography>
                <Grid2 className="login-search-box" onClick={() => document.getElementById('file-input')?.click()}>
                  {/* Estilizas el login search box como quieras */}
                  <span>Haz clic para seleccionar una imagen</span>
                </Grid2>

                {/* Input file oculto */}
                <input
                  id="file-input"
                  type="file"
                  accept="image/*"
                  className="login-search-input"
                  style={{ display: 'none' }} // Oculta el input de tipo file
                  onChange={handleImageChange} // Función que se encargará de convertir la imagen a base64
                />


                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Avatar
                    src={avatar || defaultAvatar}
                    alt="profile"
                    sx={{ width: 256, height: 256, marginRight: '8px' }}
                  />
                </Grid2>

                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Button
                    className="login-button-enviar"
                    variant="contained"
                    color="primary"
                    style={{ textTransform: 'none' }}
                    onClick={handleSubmitAvatarFinalizar}
                  >
                    Finalizar
                  </Button>
                </Grid2>
              </Grid>
            </Grid2>
          </DialogContent>
        ) : isForgetPassword ? (
          <DialogContent className="login-modal-paper">
            <Grid2 className="login-modal-content">
              <Grid2 className="main-text">
                <span className="highlight-black">Recuperar mi contraseña</span>&nbsp;
              </Grid2>
              <Grid2 className="main-text">
                <span className="highlight-gray">Se mandara un código a tu correo electronico</span>
              </Grid2>

              <Grid container direction="column" spacing={2} className="modal-container-title">
                <Typography variant="h6" className="login-title">
                  Correo Electrónico
                </Typography>
                <Grid2 className="login-search-box">
                  <input
                    className="login-search-input"
                    type="email"
                    placeholder="Ejemplo: ejemplo@correo.com"
                    value={emailRecoveryPassword}
                    onChange={(e) => setEmailRecoveryPassword(e.target.value)}
                  />
                </Grid2>

                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Button
                    className="login-button-enviar"
                    variant="contained"
                    color="primary"
                    onClick={handleRecovery}
                  >
                    Continuar
                  </Button>
                </Grid2>

              </Grid>
            </Grid2>
          </DialogContent>
        ) : isForgetPasswordStep2 ? (
          <DialogContent className="login-modal-paper">
            <Grid2 className="login-modal-content">
              <Grid2 className="main-text">
                <span className="highlight-black">Recuperar mi contraseña</span>&nbsp;
              </Grid2>
              <Grid2 className="main-text">
                <span className="highlight-gray">Se mandará un código a tu correo electrónico</span>
              </Grid2>

              <Grid container direction="column" spacing={2} className="modal-container-title">
                <Typography variant="h6" className="login-title">
                  Se mandó un correo de verificación a {emailRecoveryPassword}
                </Typography>
                <Grid2 className="code-input-container">
                  {/* Inputs individuales para cada carácter */}
                  {Array.from({ length: 6 }).map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength={1}
                      className={"code-input"}
                      value={code[index] || ""}
                      onChange={(e) => handleCodeChange(e, index)}
                    />
                  ))}
                </Grid2>

                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Typography className="text-informative">
                    El código de verificación  estará activo durante : 3:00 min
                  </Typography>

                  <Button
                    className="button-text"
                    variant="text"
                    color="primary"
                    onClick={handleRecovery}
                  >
                    Enviar un nuevo código de verificación
                  </Button>
                </Grid2>



                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Button
                    className="login-button-enviar"
                    variant="contained"
                    color="primary"
                    onClick={handleConfirmNumber}
                    disabled={code.join("").length < 6} // Deshabilitar si no están todos los caracteres
                  >
                    Confirmar
                  </Button>
                </Grid2>
              </Grid>
            </Grid2>
          </DialogContent>
        ) : isForgetPasswordStep3 ? (
          <DialogContent className="login-modal-paper-register">
            <Grid2 className="login-modal-content">
              <Grid2 className="main-text">
                <span className="highlight-gray">Restablecer tu contraseña</span>
              </Grid2>

              <Grid container direction="column" spacing={2} className="modal-container-title">
                <Typography variant="h6" className="login-title">
                  Por cuestiones de seguridad te pedimos que restablezcas tu contraseña
                </Typography>

                <Typography variant="h6" className="login-title">
                  Contraseña
                </Typography>
                <Grid2 className="login-search-box">
                  <Grid2 className="login-search-icon">
                    <IconButton onClick={handleTogglePasswordVisibility} size="small">
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </Grid2>
                  <input
                    className="login-search-input"
                    type={showPasswordRecovery ? 'text' : 'password'}
                    placeholder="Ingresa tu contraseña"
                    value={passwordRegisterRecoveryPassword}
                    onChange={(e) => setPasswordRegisterRecoveryPassword(e.target.value)}
                  />
                </Grid2>

                <Typography variant="h6" className="login-title">
                  Confirmar contraseña
                </Typography>
                <Grid2 className="login-search-box">
                  <Grid2 className="login-search-icon">
                    <IconButton onClick={handleTogglePasswordVisibility} size="small">
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </Grid2>
                  <input
                    className="login-search-input"
                    type={showPasswordConfirmRecovery ? 'text' : 'password'}
                    placeholder="Confirma tu contraseña"
                    value={passwordConfirmationRecoveryPassword}
                    onChange={(e) => setPasswordConfirmationRecoveryPassword(e.target.value)}
                  />
                </Grid2>

                {/* Botón de login */}
                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Button
                    className="login-button-enviar"
                    variant="contained"
                    color="primary"
                    onClick={handleRegisterRecoveryPassword}
                    disabled={
                      !passwordRegisterRecoveryPassword ||
                      !passwordConfirmationRecoveryPassword ||
                      passwordRegisterRecoveryPassword !== passwordConfirmationRecoveryPassword
                    }
                  >
                    Continuar
                  </Button>
                </Grid2>
              </Grid>
            </Grid2>
          </DialogContent>
        ) : isForgetUser ? (
          <DialogContent className="login-modal-paper">
            <Grid2 className="login-modal-content">
              <Grid2 className="main-text">
                <span className="highlight-black">Olvide mi usuario</span>&nbsp;
              </Grid2>
              <Grid2 className="main-text">
                <span className="highlight-gray">Por favor escribe el correo
                  electrónico con el que te diste de alta
                  ya que será en donde se mandara tu
                  nombre de usuario</span>
              </Grid2>

              <Grid container direction="column" spacing={2} className="modal-container-title">
                <Typography variant="h6" className="login-title">
                  Correo Electrónico
                </Typography>
                <Grid2 className="login-search-box">
                  <input
                    className="login-search-input"
                    type="email"
                    placeholder="Ejemplo: ejemplo@correo.com"
                    value={emailRecoveryUser}
                    onChange={(e) => setEmailRecoveryUser(e.target.value)}
                  />
                </Grid2>

                <Grid2 container justifyContent="center" alignItems="center" width="100%">
                  <Button
                    className="login-button-enviar"
                    variant="contained"
                    color="primary"
                    onClick={handleRecoveryUser}
                  >
                    Continuar
                  </Button>
                </Grid2>

              </Grid>
            </Grid2>
          </DialogContent>
        ) : (<Grid2></Grid2>)}
        {!isLoading && isLogin &&
          <>
            <Button onClick={openRegister} className='login-button-enviar' variant="contained" color="primary" style={{ textTransform: 'none' }}>
              Quiero registrarme
            </Button>
            <Button onClick={openRecoveryPassword} className='login-button-olvide' variant="text" color="primary" style={{ textTransform: 'none' }}>
              Recuperar mi contraseña
            </Button>
          </>
        }
      </Grid2>
    </Dialog>
  );
};

export default LoginModal;
